export const postContractSearch = {
    source: 'data',
    method: 'POST',
    route: '/search/multiquery',
    processBody: ({ body, }) => ({
        ...body,
        // multi query only on party index
        indexIds: ['contract'],
    }),
};
